module.exports = __webpack_public_path__ + "static/img/play-big.78a119b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets/play-big.png
// module id = /Zkm
// module chunks = 29